import { Base } from '@testsigma/organism';
import { deserialize, serializable } from 'serializr';

export class PlatformScreenResolution extends Base {
  @serializable
  resolution: string;
  @serializable
  displayResolution: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(PlatformScreenResolution, input));
  }
}
